import clsx from 'clsx';
import React from 'react';
import Image from 'next/future/image';
import { useTranslation } from 'react-i18next';

import Sort from './Sort';
import { MobileFilters } from './Filters';

import { ICategory } from '@/models';

interface Props {
  category: ICategory;
  count: number;
}

const Heading: React.FC<Props> = ({ category, count }) => {
  const { t } = useTranslation();
  return (
    <section
      className={clsx('section full no-space space-y-6', {
        'pt-6 md:pt-0': !category.image
      })}
    >
      {/* {category.image && (
        <Image
          src={category.image}
          alt={category.category_name}
          width={0}
          height={0}
          sizes="100vw"
          className="object-contain w-full h-auto"
        />
      )} */}

      <div className="flex justify-between section-wrapper">
        <div className="flex flex-col xl:flex-row xl:items-end xl:space-x-3">
          <h1 className="mb-0 h3">{category.name}</h1>
          {Boolean(count) && (
            <p className="relative text-sm -top-1">
              {count} {t('P_PLP.FILTERS.ITEMS')}
            </p>
          )}
        </div>

        <MobileFilters category={category} count={count} />

        <div className="relative hidden xl:flex xl:items-end">
          <Sort />
        </div>
      </div>
    </section>
  );
};

export default Heading;
